module.exports = __webpack_public_path__ + "img/MEDIA068.5c9025c3.jpg";